"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var helpers_1 = require("../../helpers");
var StackView_1 = require("../../StackView");
var Text_1 = require("../../Text");
var View_1 = require("../../View");
var icons_1 = require("../../icons");
var common_1 = require("../../common");
var Separator = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    width: ", ";\n    height: ", ";\n    margin-left: ", ";\n    margin-right: ", ";\n    background-color: ", ";\n"], ["\n    display: flex;\n    width: ", ";\n    height: ", ";\n    margin-left: ", ";\n    margin-right: ", ";\n    background-color: ", ";\n"])), helpers_1.BASE_BORDER_WIDTH, helpers_1.SPACING_L, helpers_1.SPACING_S, helpers_1.SPACING_S, function (_a) {
    var theme = _a.theme;
    return theme.colorBorderGrid;
});
var PageCounter = styled_components_1.default(Text_1.Text)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    padding: 0 ", ";\n"], ["\n    display: flex;\n    padding: 0 ", ";\n"])), helpers_1.SPACING_S);
var Wrapper = styled_components_1.default(StackView_1.StackView)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: inline-flex;\n"], ["\n    display: inline-flex;\n"])));
exports.CompactPagination = helpers_1.createUIElement('CompactPagination', function (_a, ref) {
    var className = _a.className, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.hasPrev, hasPrev = _c === void 0 ? true : _c, _d = _a.hasNext, hasNext = _d === void 0 ? true : _d, currentPage = _a.currentPage, onPrevClick = _a.onPrevClick, onNextClick = _a.onNextClick, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "disabled", "hasPrev", "hasNext", "currentPage", "onPrevClick", "onNextClick", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    return (react_1.default.createElement(Wrapper, __assign({}, rest, { "data-selector-id": rest['data-selector-id'], className: "vm-CompactPagination " + className, spaceLeft: hasPrev ? undefined : View_1.INDENT.l, spaceRight: hasNext ? undefined : View_1.INDENT.l, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        hasPrev && (react_1.default.createElement(common_1.PaginationButton, { "data-selector-id": "compact-pagination-previous-button", onClick: onPrevClick, disabled: disabled },
            react_1.default.createElement(icons_1.PreviousIcon, null))),
        react_1.default.createElement(Separator, null),
        currentPage !== undefined && (react_1.default.createElement(PageCounter, { view: disabled ? Text_1.TEXT_VIEW.light : Text_1.TEXT_VIEW.primary }, currentPage)),
        currentPage !== undefined && react_1.default.createElement(Separator, null),
        hasNext && (react_1.default.createElement(common_1.PaginationButton, { "data-selector-id": "compact-pagination-next-button", onClick: onNextClick, disabled: disabled },
            react_1.default.createElement(icons_1.NextIcon, null)))));
});
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=CompactPagination.js.map